import { render, staticRenderFns } from "./ScrollToIcon.vue?vue&type=template&id=08bd94d3&"
import script from "./ScrollToIcon.vue?vue&type=script&lang=js&"
export * from "./ScrollToIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports